import { getDeviceType } from '~/utils/device'

/** Fires `responsible_gaming_link_click` when the user clicks the responsible gaming link. */
export const trackResponsibleLink = (content) => {
	const params = {
		location: content.location,
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('responsible_gaming_link_click', params)
}

/** Fires `responsible_gaming_page_view` when the responsible gaming page is rendered. */
export const trackResponsibleView = () => {
	const params = {
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('responsible_gaming_page_view', params)
}

/** Fires `are_you_in_control_icon_click` when the user interacts with the self-control section icons. */
export const trackResponsibleIconSectionControl = (content) => {
	const params = {
		icon_id: content.icon_id,
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('are_you_in_control_icon_click', params)
}

/** Fires `external_support_link_click` when the user clicks an external support organisation link. */
export const trackResponsibleExternalLink = (content) => {
	const params = {
		link_name: content.link_name,
		link_url: content.link_url,
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('external_support_link_click', params)
}
